import { render } from "./CenterGate.vue?vue&type=template&id=891104be&scoped=true"
import script from "./CenterGate.vue?vue&type=script&lang=js"
export * from "./CenterGate.vue?vue&type=script&lang=js"

import "./CenterGate.vue?vue&type=style&index=0&id=891104be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-891104be"]])

export default __exports__